import x from 'common/assets/svg/common/x.svg';
import emptyFile from 'common/assets/svg/files/bordered/file-empty.svg';
import add from 'common/assets/svg/actions/add.svg';
import download from 'common/assets/svg/actions/download.svg';

type IconConfig = {
  src: string;
  className?: string;
  style: { width: number; height: number };
};

type ConfigItem = {
  className?: string;
  icon: IconConfig;
} & Partial<{ enableDownload: boolean }>;

export type AttachmentsConfigType = Record<string, ConfigItem>;

export type DownloadAttachmentSizeType = 'sm' | 'lg' | 'xl' | 'xxl';

const config: AttachmentsConfigType = {
  close: {
    className: 'border border-primary close',
    icon: {
      src: x,
      style: { width: 8, height: 8 }
    }
  },
  download: {
    enableDownload: true,
    icon: {
      src: download,
      className: 'text-primary',
      style: { width: 12, height: 12 }
    }
  },
  attachments: {
    className: '',
    icon: {
      src: emptyFile,
      className: 'text-moody-blue',
      style: { width: 10, height: 10 }
    }
  },
  add: {
    className: 'is-empty',
    icon: {
      src: add,
      style: { width: 14, height: 14 }
    }
  }
};

export default config;
